const mobileSelector = document.querySelector('#mobile_selector_id');

const openSelector = () => {
  mobileSelector.classList.add('mobile_selector_opened');
}
const closeSelector = () => {
  mobileSelector.classList.remove('mobile_selector_opened');
}



///////////////// COLOR SELECTOR/////////////////////

const  colorSelectorchild = document.querySelector('#color_selector_child');
const  colorselectorParent = document.querySelector('#color_selector_parent');

if(colorSelectorchild !== null)
  colorselectorParent.appendChild(colorSelectorchild);



///////////// VARIANT SELECTOR MOBILE ////////////////

function cloneContent() {
  targetDiv.innerHTML = sourceDiv.innerHTML;
  //targetDiv.querySelector('[data-add-to-cart-text]').innerText = sourceDiv.hasAttribute('disabled') ? theme.strings.addToCart : theme.strings.addToCart + " | ";
}
window.addEventListener('DOMContentLoaded', function () {
  const cloneAddToCart = document.querySelector('#clone-addToCart'); // Select the button
  const mainElement = document.querySelector('main'); // Select the main element

  if (cloneAddToCart && mainElement) {
    // Move the clone-addToCart button directly after <main>
    mainElement.insertAdjacentElement('afterend', cloneAddToCart);
  }
});
let stickyButtonScrollFrame = null;
window.addEventListener('scroll', function () {
  if (stickyButtonScrollFrame) return;

  stickyButtonScrollFrame = window.requestAnimationFrame(() => {
    stickyButtonScrollFrame = null;

    const stickyDiv = document.querySelector('#clone-addToCart');
    const targetDiv = document.querySelector('#mobile_selector_id');
    const desktopSelectorDiv = document.querySelector('#desktop_Selector_buttons_id');

    if (!stickyDiv || !targetDiv || !desktopSelectorDiv) return;

    const targetPosition = targetDiv.getBoundingClientRect().bottom + window.scrollY;
    const stickyDivHeight = stickyDiv.offsetHeight;
    const desktopSelectorPosition = desktopSelectorDiv.getBoundingClientRect().top;
    const shouldHide = window.scrollY + window.innerHeight >= targetPosition + stickyDivHeight && desktopSelectorPosition > 0;

    stickyDiv.style.visibility = shouldHide ? 'hidden' : 'visible';
    stickyDiv.style.zIndex = shouldHide ? -1 : 101;
  });
}, { passive: true });


const sourceDiv = document.querySelector('#addToCart-submit-btn');
const targetDiv = document.querySelector('#clone-addToCart');

targetDiv.addEventListener('click', (e) => {
  e.preventDefault();
  if(sourceDiv.hasAttribute('disabled')){
    sourceDiv.scrollIntoView({
      behavior: 'smooth',   // Scrolling behavior: 'auto' or 'smooth'
      block: 'center',       // Vertical alignment: 'start', 'center', 'end', or 'nearest'
      inline: 'nearest'     // Horizontal alignment: 'start', 'center', 'end', or 'nearest'
    });
  }else{
    targetDiv.classList.add('is-loading');
    targetDiv.disabled = true;
    sourceDiv.click()
    
    setTimeout(() => {
      targetDiv.classList.remove('is-loading');
      targetDiv.disabled = false;
    }, 2000);
  }
  
})



// Set up the MutationObserver to observe changes in the sourceDiv
const observer = new MutationObserver(function(mutationsList) {
  // Loop through mutations to check for changes
  mutationsList.forEach(function(mutation) {
    if (mutation.type === 'childList' || mutation.type === 'subtree' || mutation.type === 'characterData') {
      cloneContent();  // Call function to clone content on any change

    }
  });
});

// Observer options: we are watching for changes to child elements, subtree, or character data (text)
const observerOptions = {
  childList: true,  // Observes direct children of sourceDiv
  subtree: true,    // Observes all children and their descendants
  characterData: true // Observes changes in text nodes
};

// Start observing the sourceDiv for changes
observer.observe(sourceDiv, observerOptions);

// Initial clone (in case the targetDiv needs to be populated right away)
cloneContent();